<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
========================================================================================== -->

<template>

  <div id="page-user-list">

    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Şəhər</label>
          <v-select :options="cities" :clearable="false"  v-model="cityFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Rayon</label>
          <v-select :options="regions" :clearable="false" v-model="regionFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Bələdiyyə</label>
          <v-select :options="municipalities" :clearable="false" v-model="municipalitiesFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Partnyorlar</label>
          <v-select :options="partners" :clearable="false"  v-model="partnerFilter" />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Vergi</label>
          <v-select :options="taxes" :clearable="false" v-model="taxesFilter" class="mb-4 sm:mb-0" />
        </div>
      </div>
      <div class="vx-row">

        <ul class="demo-alignment">
          <li>
            <flat-pickr :config="filterData.configFromdateTimePicker" style="margin-left: 15px;" v-model="filterData.fromDate" placeholder="From Date"/>
          </li>
          <li>
            <flat-pickr :config="filterData.configTodateTimePicker" v-model="filterData.toDate" placeholder="To Date"  />
          </li>
          <li>
            <vs-checkbox v-model="filterData.city">Şəhər</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="filterData.region">Regiyon</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="filterData.municipality">Bələdiyyə</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="filterData.partner">Patnyor</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="filterData.tax">Vergi</vs-checkbox>
          </li>
        </ul>
        <vs-spacer></vs-spacer>

        <ul class="demo-alignment">
          <li>
            <vs-radio color="success"  v-model="filterData.date_grouped" vs-value="10">Gündəlik</vs-radio>
          </li>
          <li>
            <vs-radio color="success" v-model="filterData.date_grouped" vs-value="7">Aylıq</vs-radio>
          </li>
          <li>
            <vs-radio color="success" v-model="filterData.date_grouped" vs-value="4">İllik</vs-radio>
          </li>
        </ul>


        <vs-spacer></vs-spacer>
        <div class="demo-alignment" position="right">
<!--          <div class="vx-col md:w-1/2 sm:w-1/2 w-full">-->

<!--            <vs-input placeholder="Vergi ödəyicisinin kodu" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="filterData.userCode" class="mb-4 sm:mb-0" />-->
<!--          </div>-->

          <vs-button color="danger" v-on:click="filterGroupPayment" type="gradient" icon-pack="feather" icon="icon-search" icon-after>Axtar...</vs-button>
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center export-table">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ municipalitiesData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize :municipalitiesData.length }} of {{ municipalitiesData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
<!--             <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button>-->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>


        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
            <vs-button @click="activePrompt=true">Seç və export et</vs-button>

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="municipalitiesData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>


    <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Fayl adı.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cədvəl baslıqları ilə:</span>
        <vs-switch v-model="cellAutoWidth">Cədvəl baslıqları ilə</vs-switch>
      </div>
    </vs-prompt>

  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'


import CellRendererDate from './cell-renderer/CellRendererDate.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererTypes from '@/views/municipalities/cell-renderer/CellRendererTypes'
import moment from 'moment'


export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer

    CellRendererDate,
    CellRendererTypes,
    CellRendererActions,
    flatPickr
  },
  data () {


    return {

      testov: 'kjjk',
      // Filter Options
      activePrompt: false,
      fileName: '',
      formats:['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      headerTitle: ['Dövür', 'Şəhər', 'Region', 'Bələdiyyə', 'Vergi', 'Patnyor', 'Ödəniş'],
      headerVal: ['months', 'city_name', 'region_name', 'm_name', 'taxes_name', 'partner_name', 'amount'],

      filterData:{
        city: true,
        region: true,
        municipality:true,
        partner:true,
        tax:true,
        date_grouped:10,
        fromDate: moment(new Date()).add(-1, 'M').format('Y-MM-DD'),
        toDate:   moment(new Date()).format('Y-MM-DD')
      },


      cityFilter: { label: 'Bütün', value: 'Bütün' },
      regionFilter: {label: 'Bütün', value: 'Bütün'},
      partnerFilter: { label: 'Bütün', value: 'all' },
      taxesFilter: {label: 'Bütün', value: 'all'},
      municipalitiesFilter: {label: 'Bütün', value: 'all'},


      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [

        {
          headerName: 'Dövür',
          field: 'months',
          filter: true,
          width: 210,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: 'CellRendererDate'
          // cellRendererParams: null  //{'date_grouped_type': localStorage.getItem('date_grouped_type')}

        },
        {
          headerName: 'Şəhər',
          field: 'city_name',
          filter: true,
          width: 210
        },
        {
          headerName: 'Regiyon',
          field: 'region_name',
          filter: true,
          width: 210,
          visible: true
        },
        {
          headerName: 'Bələdiyyə',
          field: 'm_name',
          filter: true,
          width: 300


        },
        {
          headerName: 'Vergi',
          field: 'taxes_name',
          filter: true,
          width: 300

        },
        {
          headerName: 'Patnyor',
          field: 'partner_name',
          filter: true,
          width: 150
        },
        {
          headerName: 'Ödəniş',
          field: 'amount',
          filter: true,
          width: 150
        }
      ]


    }
  },
  watch: {
    cityFilter (obj) {
      this.setColumnFilter('city_name', obj.value)
      this.$store.dispatch('municipalities/fetchRegionData', obj.id).catch(err => { console.error(err) })
    },
    regionFilter (obj) {
      this.setColumnFilter('region_name', obj.value)
      this.$store.dispatch('statistics/fetchRegionMunicipalitiesData', obj.id).catch(err => { console.error(err) })
    }


    // 'filterData.date_grouped'(){
    //   localStorage.setItem('date_grouped_type', this.filterData.date_grouped)
    //
    //   alert(localStorage.getItem('date_grouped_type'))
    // },


  },
  computed: {
    municipalitiesData () {
      return this.$store.state.statistics.groupPayments
    },

    cities () {
      const cities =   this.$store.state.municipalities.cities
      const allcities = [{ label: 'Bütün', value: 'all', id:0}]
      cities.forEach((value) => {
        allcities.push({ label: value.name, value: value.name, id: value.id})
      })
      return allcities
    },
    regions () {
      const regionsData =   this.$store.state.municipalities.regions
      const regions = [{ label: 'Bütün', value: 'all'}]
      regionsData.forEach((value) => {
        regions.push({ label: value.name, value: value.name, id:value.id })
      })
      return regions
    },

    municipalities () {
      const municipalitiesData =   this.$store.state.statistics.regionMunicipalities
      const  municipalities = [{ label: 'Bütün', value: 'all'}]
      municipalitiesData.forEach((value) => {
        municipalities.push({ label: value.name, value: value.name, id:value.id })
      })
      return municipalities
    },

    partners () {
      const partnersData =   this.$store.state.statistics.partners
      const partners = [{ label: 'Bütün', value: 'all'}]
      partnersData.forEach((value) => {
        partners.push({ label: value.name, value: value.name, id:value.id   })
      })
      return partners
    },
    taxes () {
      const taxesData =   this.$store.state.statistics.taxes
      const taxes = [{ label: 'Bütün', value: 'all'}]
      taxesData.forEach((value) => {
        taxes.push({ label: value.name, value: value.name, id:value.id })
      })
      return taxes
    },


    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },

    dateType () {
      return  this.filterData.date_grouped
    }


  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },


    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.cityFilter =  this.regionFilter = this.partnerFilter  = this.taxesFilter = { label: 'Bütün', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },

    filterGroupPayment () {

      this.gridOptions.columnApi.setColumnVisible('city_name', this.filterData.city)
      this.gridOptions.columnApi.setColumnVisible('region_name', this.filterData.region)
      this.gridOptions.columnApi.setColumnVisible('partner_name', this.filterData.partner)
      this.gridOptions.columnApi.setColumnVisible('taxes_name', this.filterData.tax)
      this.gridOptions.columnApi.setColumnVisible('m_name', this.filterData.municipality)

      this.$store.dispatch('statistics/fetchGroupPaymentStatisticsData',
        {...this.filterData, city_id:this.cityFilter.id, region_id:this.regionFilter.id, municipality_id:this.municipalitiesFilter.id, partner_id:this.partnerFilter.id, taxes_id :this.taxesFilter.id }
      ).catch(err => { console.error(err) })
    },


    exportToExcel () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const list = selectedNodes.map(node => node.data)
      import('@/vendor/Export2Excel').then(excel => {
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields () {
      this.fileName = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }

  },
  mounted () {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    // if (!moduleUserManagement.isRegistered) {
    //   this.$store.registerModule('userManagement', moduleUserManagement)
    //   moduleUserManagement.isRegistered = true
    // }
    this.$store.dispatch('municipalities/fetchMunicipalitiesData').catch(err => { console.error(err) })
    this.$store.dispatch('municipalities/fetchCitiesData').catch(err => { console.error(err) })
    this.$store.dispatch('statistics/fetchPartnersData').catch(err => { console.error(err) })
    this.$store.dispatch('statistics/fetchTaxesData').catch(err => { console.error(err) })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
